var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverFlowDonorBoxSettings = function SvgOverFlowDonorBoxSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9802",
    transform: "translate(-122 -634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#7c9ac7",
    "data-name": "Rectangle 59",
    rx: 6,
    transform: "translate(122 634)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.475 667.984h-21.363a1.107 1.107 0 0 1-1.112-1.191v-21.602a1.107 1.107 0 0 1 1.112-1.191h10.642a1.107 1.107 0 0 1 1.112 1.191v3.336a1.154 1.154 0 0 1-1.112 1.191 1.107 1.107 0 0 1-1.112-1.191V646.3h-8.418v19.381h19.139V646.3h-2.7a1.154 1.154 0 0 1-1.112-1.191 1.023 1.023 0 0 1 1.032-1.109h3.817a1.107 1.107 0 0 1 1.112 1.191v21.681a1.067 1.067 0 0 1-1.037 1.112",
    "data-name": "Path 1160"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M146.216 658.771a4.75 4.75 0 0 0 2.065-3.418 2.116 2.116 0 0 0-2.065-2.3 3 3 0 0 0-1.271.238 1.4 1.4 0 0 0-.556.4l-.556.556-.556-.556a2.4 2.4 0 0 0-.556-.4 3 3 0 0 0-1.271-.238 2.116 2.116 0 0 0-2.064 2.3c0 1.112.715 2.224 2.065 3.415a10.4 10.4 0 0 0 2.382 1.588 15.4 15.4 0 0 0 2.383-1.585",
    "data-name": "Path 1161"
  })))));
};
export default SvgOverFlowDonorBoxSettings;